export const cacheKeys = {
  getAppointmentStatuses: (params) =>
    params ? ['getAppointmentStatuses', params] : ['getAppointmentStatuses'],
};
